export default class Countdown {
  constructor() {
    this.$el = document.querySelector('.js-countdown');

    if (! this.$el) return

    const launch = new Date(parseInt(this.$el.dataset.launch) * 1000).getTime()

    const tick = () => {
      const now = new Date().getTime();

      const distance = launch - now;

      if (distance < 0) {
        return
      }

      const props = {
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distance % (1000 * 60)) / 1000),
      }

      for (const [key, value] of Object.entries(props)) {
        document.querySelector('.js-' + key).innerHTML = value
      }
    }

    tick()
    setInterval(tick, 1000)
  }
}
